import { render, staticRenderFns } from "./bank_user.vue?vue&type=template&id=831f0f2e&scoped=true"
import script from "./bank_user.vue?vue&type=script&lang=js"
export * from "./bank_user.vue?vue&type=script&lang=js"
import style0 from "./bank_user.vue?vue&type=style&index=0&id=831f0f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831f0f2e",
  null
  
)

export default component.exports